import { Box } from '@material-ui/core';
import { formatDateTimeReadable, getMoneySymbolByCurrency, Money } from '@nemuru-eng/js-api-client';

import { OrderActionType } from '@/components/modules/OrderActivity/types/OrderActionType';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export function ActionSummary(props: {
  type: OrderActionType;
  number: number | undefined;
  tag?: JSX.Element;
  createdAt: Date;
  amount: Money;
}) {
  const shippingNumberText = <Text tId={'CAPTURE_NUMBER'} dynamicDataTexts={[`${props.number}`]} />;
  const refundNumberText = <Text tId={'REFUND_NUMBER'} dynamicDataTexts={[`${props.number}`]} />;
  const payoutNumberText = <Text tId={'PAYOUT_NUMBER'} dynamicDataTexts={[`${props.number}`]} />;

  return (
    <>
      <Box display={'grid'} flexGrow={1}>
        <Box py={'4px'}>
          <Font variant={'body2'} color={'title'}>
            <strong>
              {props.type === OrderActionType.capture
                ? shippingNumberText
                : props.type === OrderActionType.refund
                ? refundNumberText
                : props.type === OrderActionType.payout
                ? payoutNumberText
                : Text({ tId: 'ORDER_CREATED' })}
            </strong>
          </Font>
          <Box ml={2} display={'inline'} style={{ verticalAlign: 'text-bottom' }}>
            {props.tag}
          </Box>
        </Box>
        <Font variant={'caption'} color={'textSecondary'}>
          {formatDateTimeReadable(props.createdAt)}
        </Font>
      </Box>
      <Box display={'flex'} alignItems={'center'}>
        <Font variant={'body1'} color={'title'}>
          <strong>
            {props.type === OrderActionType.refund
              ? `  ${(-1 * props.amount.value).toFixed(2)} ${getMoneySymbolByCurrency(props.amount.currency)}`
              : `  ${props.amount.value.toFixed(2)} ${getMoneySymbolByCurrency(props.amount.currency)}`}
          </strong>
        </Font>
      </Box>
    </>
  );
}
